<template>
  <div id="app">
    <a-config-provider :locale="zh_CN" :transformCellText="transformCellTextAction">
      <keep-alive :include="cacheVueComponents.join(',')">
        <router-view></router-view>
      </keep-alive>
    </a-config-provider>
  </div>
</template>

<script>
  import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
  require('ant-design-vue/dist/antd.css');
  require('./utils/css/custom_antd.css');
  require('./utils/css/base.css');
  require('./utils/css/pc.css');

  require('./utils/js/constant');
  require('./utils/js/jquery.min');
  require('./utils/js/hy-common-tool');
  require('./utils/js/hy-date-tool');

  export default {
    name: 'App',
    computed: {},
    data() {
      return {
        zh_CN,
        cacheVueComponents: ['Index'],
      }
    },
    mounted() {
      // this.forbiddenBrowerBack();
    },
    methods: {
      /**
       * 全局替换Table中的空字符串
       * @param text
       * @param column
       * @param record
       * @param index
       * @returns {string|*}
       */
      transformCellTextAction({text, column, record, index}) {
        if (text === null || text === undefined) {
          return '无';
        }
        return text;
      }
    },
    watch: {
      '$route'(to, from) {

      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue